import { deleteWorkspace } from "api/services/workspace-service";
import useApiCall from "hooks/useApiCall"

export const useDeleteWorkspace = () => {
    const { callAPI, loading } = useApiCall(deleteWorkspace, 'deleteWorkspace.success', 'deleteWorkspace.error');

    return { deleteWorkspace: callAPI, deletingWorkspace: loading }
}